import React, { Component } from "react";
import PropTypes from "prop-types";
import styled from "styled-components";
import { TimePicker, LocaleProvider } from "antd";
import enUS from "antd/lib/locale-provider/en_US";
import moment from "moment";
import Input from "module-common/Input";
import TextArea from "module-common/TextArea";
import Picker from "module-common/Picker";
import Icon from "module-common/Icon";
import Label from "module-common/label-list/Label"

export default class InputRow extends Component {
  static propTypes = {
    label: PropTypes.string.isRequired,
    afterLabel: PropTypes.string,
    labelWidth: PropTypes.number,
    inputWidth: PropTypes.number,
    value: PropTypes.any,
    type: PropTypes.oneOf(["text", "password", "textarea", "timepicker", "dropdown"]),
    defaultValue: PropTypes.string,
    onChange: PropTypes.func,
    disabled: PropTypes.bool,
    zIndex: PropTypes.number
  };
  static defaultProps = {
    labelWidth: 150,
    type: "text",
    zIndex: 1
  };

  state = {}

  render() {
    const {
      label,
      afterLabel,
      labelWidth,
      inputWidth,
      type,
      value,
      defaultValue,
      className,
      disabled,
      zIndex,
      containerWidth,
      containerHeight
    } = this.props;
    const { selectedDropdown } = this.state
    return (
      <Row className={className} width={containerWidth} height={containerHeight} >
        <InputLabel width={labelWidth}>{label}</InputLabel>
        {type === "textarea" && (
          <TextArea
            rows={3}
            value={value}
            onChange={this.onChange}
            defaultValue={defaultValue}
            width={inputWidth}
            disabled={disabled}
          />
        )}
        {(type === "text" || type === "password") && (
          <Input
            type={type}
            value={value}
            onChange={this.onChange}
            defaultValue={defaultValue}
            width={inputWidth}
          />
        )}
        {type === "timepicker" && (
          <LocaleProvider locale={enUS}>
            <TimePicker
              value={value}
              onChange={this.onTimeChange}
              defaultOpenValue={moment("00:00:00", "HH:mm:ss")}
            />
          </LocaleProvider>
        )}
        {type === "dropdown" &&  (
         
          <Row>
             {!!value.length && (<Picker
                margin={0}
                options={value}
                onSelected={(row, options) => {
                  this.setState({...this.state, selectedDropdown: row})
                  this.onSelected(row)
                }}
                zIndex={zIndex}
              >
                <div>
                  <Icon
                    name="arrow-down"
                    width={12}
                  />
                </div>
              </Picker>)}
            {!!!value.length && <div>No option available</div>}            
            {selectedDropdown && (
              <Selected>
                <Label 
                  name={selectedDropdown.label}
                  removable={true}
                  onRemove={() => {
                      this.setState({...this.state, selectedDropdown: null })
                      this.onSelected(null)
                  }} 
                />
              </Selected>
            )}
          </Row>
        )}
        
        <AfterLabel>{afterLabel}</AfterLabel>
      </Row>
    );
  }

  onChange = event => {
    const onChange = this.props.onChange;
    if (onChange) onChange(event.target.value);
  };

  onTimeChange = (time, timeString) => {
    const onChange = this.props.onChange;
    if (onChange) onChange(time, timeString);
  };

  onSelected = (selected) => {
    const onChange = this.props.onChange;
    if (onChange) onChange(selected)  
  }
}

const Row = styled.label`
  display: flex;
  flex: none;
  width: ${props => props.width};
  height: ${props => props.height};
`;
const InputLabel = styled.span`
  flex: none;
  width: ${props => props.width}px;
  font-size: 0.9rem;
  margin-top: 4px;
`;
const AfterLabel = styled.span`
  font-size: 0.9rem;
  margin-top: 4px;
  margin-left: 10px;
`;
const Selected = styled.div`
  margin-left: 5px;
`



// WEBPACK FOOTER //
// ./src/module-common/InputRow.js